import { ReusableNotesField } from './ReusableNotesField';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { SyncManager } from 'db';

const createInspectorNotesKey = (sectionId: string, field?: string) => {
  return [sectionId, field].filter(Boolean).join('.');
};

export const FinalReviewInspectorNotes = () => {
  const id = useFormVehicleId();

  const save = async (notes: string | null, fieldName = 'notes') => {
    const syncManager = SyncManager.getInstance(id);
    await syncManager.queueVehicleUpdate([`inspector_notes.${fieldName}`, notes]);
  };

  return <ReusableNotesField getFieldKey={createInspectorNotesKey} save={save} aiNotes sectionId={'inspector_notes'} />;
};
